// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B008","toggleWrap":"styles_toggleWrap__3gCwa","content":"styles_content__3-y_P","selectAreaCode":"styles_selectAreaCode__1WOjx"};